export class Indicator{
  id= null;
  code= null;
  name= null;
  definition= null;
  concepts= [];
  measurement= null;
  measurement_unit= null;
  subject_field= null;
  benefit= null;
  interpretation= null;
  presentation_levels= [];
  calculation_mechanism= null;
  formula= null;
  formula_structures= [];
  disaggregations= [];
  references= [];
}
export class UpdatedIndicator {
  changes_type=null;
	items=[];
}
export default class IndicatorSubmission{
  code= null;
  name= null;
  definition= null;
  concepts= [];
  measurement= null;
  measurement_unit= null;
  subject_field= null;
  benefit= null;
  interpretation= null;
  presentation_levels= [];
  calculation_mechanism= null;
  formula= null;
  formula_structures= [];
  disaggregations= [];
  references= [''];
  updated_indicator= null;
}
